import { useAppDispatch, useAppSelector } from 'src/redux/hooks';

export const useDevConfigBannerImpl = () => {
  const data = useAppSelector(state => state.devConfig);
  const dispatch = useAppDispatch();

  const onClickNext = () => {
    dispatch({ type: 'devConfig/onNextServer' });
  };

  const state = { data };
  return { onClickNext, state };
};
